module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Forever Christmas")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc-0"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#p0007-01-0"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter2#p0009-01-0"
    }
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter3#p0015-01-0"
    }
  }, [_vm._v("CHAPTER TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#p0023-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#p0035-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#p0043-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#p0047-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#p0053-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#p0057-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#p0067-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#p0073-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#p0079-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#p0095-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#p0103-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#p0115-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#p0129-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#p0143-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIXTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#p0149-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVENTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#p0153-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#p0159-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINETEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#p0163-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#p0173-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#p0177-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#p0181-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#p0183-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("READING GROUP GUIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#p0187-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "toc-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#p0189-01-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0